var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"tachi15Header"}},[_c('b-container',[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Tachi.ai 15")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }